document.addEventListener("DOMContentLoaded", () => {
    document.body.addEventListener('click', (event) => {
        const externalVideoSlide = event.target.closest('.swiper-slide.main-swiper-slide.external-video');

        if (externalVideoSlide) {
            const externalVideoModal = externalVideoSlide.querySelector('dialog.external_video_modal');
            const externalVideoModalRect = externalVideoModal.getBoundingClientRect();

            if (externalVideoModal && !externalVideoModal.open) {
                externalVideoModal.showModal();
                externalVideoModal.style.display = 'flex';
            }
            const isOutsideClick = (event, modalRect) => 
                event.clientX < modalRect.left || 
                event.clientX > modalRect.right || 
                event.clientY < modalRect.top || 
                event.clientY > modalRect.bottom;

        if (event.target.classList.contains('modal-close') || isOutsideClick(event, externalVideoModalRect) ) {
            const externalVideoModal = event.target.closest('dialog.external_video_modal');
            if (externalVideoModal) {
                const youtubeIframe = externalVideoModal.querySelector('iframe');

                externalVideoModal.classList.add('exit'); 

                setTimeout(() => {
                    externalVideoModal.close();
                    externalVideoModal.removeAttribute("open");
                    externalVideoModal.style.display = 'none';
                    externalVideoModal.classList.remove('exit'); 
                }, 300); 

                // Reset video playback
                if (youtubeIframe) {
                    youtubeIframe.src = youtubeIframe.src;
                }
            }
        }
        }
    });
});